import React from "react";
import { connect } from "react-redux";
import Error from "~/src/pages/_error.js";
import { firebase, getStudioData, getThumbnailURL } from "~/src/api";
import { AppWithAuthentication, Head, Layout } from "~/src/components/global";
import { StudioDetail } from "~/src/components/studios";

const Studio = (props) => {
  const { studio, authUser } = props;

  if (!studio) {
    return <Error />;
  }

  return (
    <AppWithAuthentication>
      <Layout size="sm">
        <Head
          title={`${studio.name} · Studios · Bolstr`}
          image={getThumbnailURL({
            url: studio.photo,
            size: 512,
          })}
          description={studio.description}
        />

        <StudioDetail
          authUser={authUser}
          studio={studio}
        />
      </Layout>
    </AppWithAuthentication>
  );
};

Studio.getInitialProps = async function ({ query }) {
  const studio = await firebase.studio(query.id).get();

  return {
    studio: await getStudioData({ studio, withJobs: true, withLocations: true }),
  };
};

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser,
});

export default connect(mapStateToProps)(Studio);
